import React, { FC, useMemo } from 'react'
import block from 'bem-cn'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { useDatePickerContext } from '../DatePickerProvider/DatePickerContext'
import { ReactComponent as ArrowSVG } from '../img/arrow.svg'
import { DatePickerVariant, IntervalVariants } from '../types'

import './ControlDateSelection.scss'

const b = block('control-date-selection')

const ControlDateSelection: FC = () => {
  const { tPrefix } = useAppTranslation('common')
  const { controlDate, nextControlDate, prevControlDate, interval, variant, changeInterval } = useDatePickerContext()

  const leftControlText = useMemo(() => {
    if (interval === IntervalVariants.DAY && variant !== DatePickerVariant.DATE) {
      return tPrefix(`month.${controlDate.getMonth() + 1}`)
    }

    return ''
  }, [controlDate, variant, interval, tPrefix])

  const rightControlText = useMemo(() => {
    if (interval === IntervalVariants.DAY && variant !== DatePickerVariant.DATE) {
      return tPrefix(`month.${(controlDate.getMonth() + 2) % 13 || 1}`)
    }

    return ''
  }, [controlDate, variant, interval])

  const centerText = useMemo(() => {
    if (variant === DatePickerVariant.DATE) {
      return interval === IntervalVariants.DAY
        ? `${tPrefix(`month.${controlDate.getMonth()}`)} ${controlDate.getFullYear()}`
        : controlDate.getFullYear()
    }
    return controlDate.getFullYear()
  }, [controlDate, variant, interval, tPrefix])

  const handleClickCenter = (e: React.SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    changeInterval(IntervalVariants.MONTH)
  }

  return (
    <div className={b('wrapper').mix(variant)}>
      <button type="button" className={b('control').mix(variant)} onClick={prevControlDate}>
        <ArrowSVG className={b('control-icon').mix('left')} />
        {leftControlText && <div className={b('control-text')}>{leftControlText}</div>}
      </button>
      <button type="button" className={b('center-value')} onClick={handleClickCenter}>
        {centerText}
      </button>
      <button type="button" className={b('control').mix(variant)} onClick={nextControlDate}>
        {rightControlText && <div className={b('control-text')}>{rightControlText}</div>}
        <ArrowSVG className={b('control-icon').mix('right')} />
      </button>
    </div>
  )
}

export { ControlDateSelection }
